// 便名コードの一般的な説明（航空会社コード + 便名番号）に合わせたベストエフォートな表示用パターン。
// 参考: https://ja.wikipedia.org/wiki/%E4%BE%BF%E5%90%8D
// 例: NH12, JL1234, ANA52A, NH-12

export const FLIGHT_CODE_PATTERN = /[A-Z0-9]{1,3}-?\d{1,4}[A-Z]?/i;
